export default __webpack_public_path__ + "static/media/NZ.35137dc5.ico";